import { render, staticRenderFns } from "./result-dialog.vue?vue&type=template&id=1710f1fc&scoped=true&"
import script from "./result-dialog.vue?vue&type=script&lang=js&"
export * from "./result-dialog.vue?vue&type=script&lang=js&"
import style0 from "./result-dialog.vue?vue&type=style&index=0&id=1710f1fc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1710f1fc",
  null
  
)

export default component.exports